import { MagnifyingGlass } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Input } from '@creditornot/cb-input';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

type Props = {
  onSearch: (value: string) => void;
  searchInput: string;
};

const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 22px 24px;
  align-items: center;
  justify-content: space-between;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Typography.Heading5).attrs({ fontWeight: 'bold' })`
  display: flex;
  align-items: center;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SearchInput = styled(Input)`
  width: 274px;
`;

export const SelectionListToolbar = ({ onSearch, searchInput }: Props) => {
  const intl = useIntl();
  return (
    <Root>
      <Title>
        <FormattedMessage id="listing-manager.selections.toolbar.title" />
      </Title>
      <ActionsContainer>
        <Left>
          <SearchInput
            value={searchInput}
            icon={<MagnifyingGlass />}
            onClearClick={() => onSearch('')}
            placeholder={intl.formatMessage({ id: 'listing-manager.selections.toolbar.search-placeholder' })}
            onChange={e => onSearch(e.target.value)}
          />
        </Left>
      </ActionsContainer>
    </Root>
  );
};
